import { Button, styled, TextField } from '@mui/material';

const CustomButton = styled(Button)({
  backgroundColor: '#000',
  color: '#fff',
  padding: '14px',
  fontWeight: 700,
  marginTop: '24px',
  letterSpacing: '0.1em',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: '#333',
  },
  '&:active': {
    transform: 'scale(0.98)',
  },
});

const CustomTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',

    '&.Mui-focused fieldset': {
      border: '2px solid #000',
    },
  },

  '& .MuiOutlinedInput-notchedOutline': {
    legend: { display: 'none' },
  },

  '& .MuiInputLabel-root': {
    color: '#5f5e5e',
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: '14px',
    marginBottom: '8px',
    position: 'relative',
    transform: 'none',
    letterSpacing: '0.05em',
    textAlign: 'left',

    '&.Mui-focused': {
      color: '#5f5e5e',
    },

    '&.Mui-error': {
      color: '#d32f2f',
    },
  },

  '& .MuiInputBase-input': {
    padding: '14px',
  },
});

export { CustomButton, CustomTextField };
